<template>
	<smart-link
		v-if="privatePageUrl"
		class="segments__link"
		:class="{ 'segments__link--active': isPrivatePageActive }"
		:url="privatePageUrl"
		:trackingData="gtmNavigationalTracking(privateLabel, 'top navigation', privatePageUrl)"
	>
		{{ privateLabel ?? 'Privat' }}
	</smart-link>
	<span
		v-if="businessPageUrl"
		class="segments__link--divider"
	></span>
	<smart-link
		v-if="businessPageUrl"
		class="segments__link"
		:class="{ 'segments__link--active': isBusinessPageActive }"
		:url="businessPageUrl"
		:trackingData="gtmNavigationalTracking(businessLabel, 'top navigation', businessPageUrl)"
	>
		{{ businessLabel ?? 'Erhverv' }}
	</smart-link>
	<span
		v-if="agriculturePageUrl"
		class="segments__link--divider"
	></span>
	<smart-link
		v-if="agriculturePageUrl"
		class="segments__link"
		:class="{ 'segments__link--active': isAgriculturePageActive }"
		:url="agriculturePageUrl"
		:trackingData="gtmNavigationalTracking(agricultureLabel || 'Landbrug', 'top navigation', agriculturePageUrl)"
	>
		{{ agricultureLabel }}
	</smart-link>
</template>

<script setup lang="ts">
	import { computed } from 'vue';
	import { useRoute } from 'vue-router';
	import { gtmNavigationalTracking } from '@/components/utilities/trackingUtility';

	const route = useRoute();

	const props = defineProps<{
		privateLabel: string;
		privatePageUrl?: string;
		businessLabel: string;
		businessPageUrl?: string;
		agricultureLabel?: string;
		agriculturePageUrl?: string;
	}>();

	// Helper function to check if path matches a section (with or without trailing slash)
	const pathMatchesSection = (path: string, sectionUrl: string) => {
		const normalizedPath = path.replace(/\/$/, ''); // Remove trailing slash
		const normalizedSection = sectionUrl.replace(/\/$/, ''); // Remove trailing slash

		return normalizedPath === normalizedSection || normalizedPath.startsWith(normalizedSection + '/');
	};

	const isBusinessPageActive = computed(() => {
		const businessUrl = props.businessPageUrl || '/erhverv';
		const agricultureUrl = props.agriculturePageUrl;

		return (
			pathMatchesSection(route.path, businessUrl) &&
			!(agricultureUrl && pathMatchesSection(route.path, agricultureUrl))
		);
	});

	const isAgriculturePageActive = computed(() => {
		const agricultureUrl = props.agriculturePageUrl || '/landbrug';
		return pathMatchesSection(route.path, agricultureUrl);
	});

	const isPrivatePageActive = computed(() => {
		return !isBusinessPageActive.value && !isAgriculturePageActive.value;
	});
</script>

<style lang="scss">
	@import './TopNavigation.module.scss';
</style>
